import React, { useState } from 'react';
import api from '../../services/api';

function StarButton({ value, selected, onClick }) {
  return (
    <button
      onClick={() => onClick(value)}
      style={{
        fontSize: 36, background: 'none', border: 'none', cursor: 'pointer',
        color: selected ? '#f59e0b' : '#e2dbd0',
        transform: selected ? 'scale(1.1)' : 'scale(1)',
        transition: 'all .15s',
        padding: '4px',
      }}
    >
      ★
    </button>
  );
}

const STAR_LABELS = { 1: 'Muy malo', 2: 'Malo', 3: 'Regular', 4: 'Bueno', 5: 'Excelente' };

export default function RatingModal({ order, onClose, onSubmitted }) {
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!stars) { setError('Selecciona una calificación'); return; }
    setLoading(true); setError('');
    try {
      await api.post(`/api/v1/ratings/order/${order.ref}`, { stars, comment: comment || null });
      onSubmitted && onSubmitted(order.ref);
      onClose();
    } catch (e) {
      setError(e.response?.data?.detail || 'Error al enviar la calificación');
    } finally { setLoading(false); }
  };

  const displayStars = hover || stars;

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 1000 }} />
      <div style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
        background: '#fff', borderRadius: 20, width: 'min(440px, 92vw)',
        zIndex: 1001, padding: 28, boxSizing: 'border-box',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 18 }}>Calificar servicio</div>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#7a7060' }}>✕</button>
        </div>

        {/* Order info */}
        <div style={{ background: '#f9f6f1', borderRadius: 10, padding: '12px 14px', marginBottom: 20 }}>
          <div style={{ fontFamily: 'monospace', fontSize: 11, color: '#c94a1e', marginBottom: 2 }}>{order.ref}</div>
          <div style={{ fontSize: 14, fontWeight: 600 }}>{order.recipient_name}</div>
          {order.agent_name && (
            <div style={{ fontSize: 12, color: '#7a7060', marginTop: 2 }}>Agente: {order.agent_name} · {order.agent_code}</div>
          )}
        </div>

        {/* Stars */}
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <div
            style={{ display: 'flex', justifyContent: 'center', gap: 4 }}
            onMouseLeave={() => setHover(0)}
          >
            {[1, 2, 3, 4, 5].map(v => (
              <button key={v}
                onMouseEnter={() => setHover(v)}
                onClick={() => setStars(v)}
                style={{ fontSize: 40, background: 'none', border: 'none', cursor: 'pointer', color: v <= displayStars ? '#f59e0b' : '#e2dbd0', transition: 'all .1s', padding: '2px 4px' }}>
                ★
              </button>
            ))}
          </div>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#0f0d0b', minHeight: 20, marginTop: 4 }}>
            {displayStars ? STAR_LABELS[displayStars] : 'Toca para calificar'}
          </div>
        </div>

        {/* Comment */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 6 }}>
            Comentario (opcional)
          </label>
          <textarea
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #e2dbd0', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box', resize: 'vertical', minHeight: 70 }}
            placeholder="¿Cómo fue el servicio? Tu opinión ayuda a otros usuarios..."
            value={comment}
            onChange={e => setComment(e.target.value)}
            maxLength={300}
          />
          <div style={{ fontSize: 11, color: '#b0a090', textAlign: 'right' }}>{comment.length}/300</div>
        </div>

        {error && (
          <div style={{ background: '#faeef4', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: 13, color: '#9b2c5e' }}>⚠ {error}</div>
        )}

        <button onClick={handleSubmit} disabled={loading || !stars} style={{
          width: '100%', padding: '13px', borderRadius: 10, border: 'none',
          background: (loading || !stars) ? '#e2dbd0' : '#c94a1e',
          color: '#fff', fontSize: 15, fontWeight: 700,
          cursor: (loading || !stars) ? 'not-allowed' : 'pointer',
        }}>
          {loading ? 'Enviando...' : `Calificar con ${stars ? stars + '★' : '...'}`}
        </button>
      </div>
    </>
  );
}
